import MyBusinessAnnouncementContent from './MyBusinessAnnouncementContent.jsx';
import MyBusinessAnnouncementDetailContent from './MyBusinessAnnouncementDetailContent.jsx';

export {
  MyBusinessAnnouncementContent,
  MyBusinessAnnouncementDetailContent
};



// WEBPACK FOOTER //
// ./components/my-business/sub-view/announcement/index.js